<template>
  <v-card class="ma-3" :style="cardClass" id="screen-locations">
    <div class="d-flex justify-space-between pr-4">
      <h3 class="py-3 pl-4">
        SCREEN LOCATIONS
      </h3>
    </div>
    <v-layout class="d-flex flex-column" v-if="locations">
      <GmapMap
        :center="{ lat: userPosition.lat, lng: userPosition.lng }"
        ref="map"
        style="width: 100%; height: 600px;"
        :options="mapStyle"
        @tilt_changed="getNextSection()"
      >
        <GmapMarker
          v-for="(device, i) in locations"
          :key="i"
          :position="{
            lng: Number(device.longitude),
            lat: Number(device.latitude),
          }"
          :radius="100"
          :icon="{
            url: device.marker,
            scaledSize: { width: 28, height: 28 },
          }"
          @click="device.infoOpen = !device.infoOpen"
          :visible="true"
          :options="{
            fillColor: $vuetify.theme.currentTheme.primary,
            fillOpacity: 1.0,
          }"
        ></GmapMarker>
      </GmapMap>
      <data-card :noMargin="true">
        <v-row class="font-weight-bold d-flex pt-4 d-flex justify-space-around">
          <span class="pr-8 pl-5" style="width:33%;">Latititude</span>
          <span class="pr-4" style="width:33%;">Longitude</span>
          <span style="width:33%;">Date</span>
        </v-row>
      </data-card>
      <data-card v-for="(device, i) in locations" :key="i" :noMargin="true">
        <v-row
          style="font-size:14px; height:100%;"
          class="d-flex justify-space-around"
          @click="updatePin(device, i)"
        >
          <span class="pr-8 pl-5" style="width:33%;">{{
            device.latitude
          }}</span>
          <span class="pr-4" style="width:33%;">{{ device.longitude }}</span>
          <span style="width:33%;">{{ getDate(device.created_at) }}</span>
        </v-row>
      </data-card>
      <v-pagination
        v-model="currentPage"
        :length="pages"
        @input="getNextSection()"
        :total-visible="5"
        color="primary"
      ></v-pagination>
    </v-layout>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import Vue from 'vue';
import moment from 'moment';
import ScreenDetailData from '@/mixins/ScreenDetailData';
import mapStyles from '../../assets/mapstyles.json';
import DataCard from '@/components/app/DataCard.vue';
import card from '@/mixins/card';
import { MobileView } from '@/mixins';

export default {
  components: {
    DataCard,
  },
  mixins: [ScreenDetailData, card, MobileView],
  data: () => ({
    locations: [],
    currentPage: 1,
    mapStyle: mapStyles,
    bounds: null,
    userPosition: {
      lat: 39.71706,
      lng: -104.966553,
    },
  }),
  methods: {
    updatePin(device, index) {
      this.locations = [];
      this.locations = this.data.coordinates.items.slice(
        (this.currentPage - 1) * 6,
        this.currentPage * 6
      );
      this.locations.map((loc, index) => {
        if (this._client.client_name === 'avis') {
          loc.marker = require('../../assets/Avis-Car.svg');
        } else if (this._client.client_name === 'bazzbi') {
          loc.marker = require('../../assets/golf-cart-CC.svg');
        } else if (
          this._client.client_name === 'shark' &&
          index === 0 &&
          this.currentPage === 1
        ) {
          loc.marker = require('../../assets/SharkFlag-green@3x.svg');
        } else if (this._client.client_name === 'shark') {
          loc.marker = require('../../assets/SharkFlag@3x.svg');
        }
      });
      if (this._client.client_name === 'shark') {
        this.locations.map(loc => {
          loc.marker = loc.marker = require('../../assets/SharkFlag@3x.svg');
        });
        Vue.set(
          this.locations[index],
          'marker',
          require('../../assets/SharkFlag-green@3x.svg')
        );
        // this.$refs.map.resize();
      }
    },
    getDate(rawDate) {
      const formatted = moment(rawDate).format('MM-DD-YYYY h:mm:ss');
      return formatted;
    },
    getNextSection() {
      this.locations = [];
      this.locations = this.data.coordinates.items.slice(
        (this.currentPage - 1) * 6,
        this.currentPage * 6
      );
      this.locations.map((loc, index) => {
        if (this._client.client_name === 'avis') {
          loc.marker = require('../../assets/Avis-Car.svg');
        } else if (this._client.client_name === 'bazzbi') {
          loc.marker = require('../../assets/golf-cart-CC.svg');
        } else if (
          this._client.client_name === 'shark' &&
          index === 0 &&
          this.currentPage === 1
        ) {
          loc.marker = require('../../assets/SharkFlag-green@3x.svg');
        } else if (this._client.client_name === 'shark') {
          loc.marker = require('../../assets/SharkFlag@3x.svg');
        }
      });
    },
  },
  computed: {
    ...mapGetters({
      _client: 'account/getCurrentClient',
    }),
    pages() {
      const count = this.data.coordinates.items.length;
      if (count <= 6) {
        return 1;
      }
      return Math.ceil(count / 6);
    },
    newWidth() {
      if (this.showMobileView) {
        return this.cardWidth;
      }
      return '90%';
    },
    cardClass() {
      if (this.showMobileView) {
        return 'width:calc(100% - 24px);';
      }
      return 'width:calc(50% - 24px); overflow:hidden;';
    },
  },
  watch: {
    locations: {
      handler() {
        const bounds = new window.google.maps.LatLngBounds();
        for (const m of this.locations) {
          const position = {
            lng: Number(m.longitude),
            lat: Number(m.latitude),
          };
          bounds.extend(position);
        }
        this.bounds = bounds;
      },
      deep: true,
    },
    bounds: {
      handler() {
        this.$refs.map.$mapObject.fitBounds(this.bounds);
      },
      deep: true,
    },
    data: {
      handler() {
        this.getNextSection();
      },
      deep: true,
    },
  },
};
</script>

<style></style>
